/**
 * Se usa en Contact form, job form y subscribe
 */
export default function FormModule(element) {

    let $generalError = element.querySelector('.form__general__error');
    
    element.addEventListener('submit',  function(event) {

        event.stopPropagation();
        event.preventDefault();

        clearFormErrors();

        setLoading(true);

        fetch(window.WP_ADMIN_URL + '/admin-ajax.php', {
            method: 'POST',
            body: new FormData(element)
        })
        .then(response => response.json())
        .then(function(res) {
            setLoading(false);


            if (res.errors) {
                displayErrors(res.errors);
            } else if (res.result !== 1) {
                showGeneralError(res.msg || 'Lo sentimos, ha ocurrido un error');
            } else {
                showThanks();
            }
        }).catch(function(err) {
            setLoading(false);
            console.error(err);
            showGeneralError('Lo sentimos, ha ocurrido un error.');
        })
    });

    function displayErrors(errors) {
        for (let fieldName in errors) {
            let input = element.querySelector('*[name='+fieldName+']');
            let formGroup = input.closest('.form__group');
            let formError = formGroup.querySelector('.form__error');

            formGroup.classList.add('has-error');
            if (formError) {
                formError.style.display = 'block';
                formError.innerText = errors[fieldName];
            }
        }
    }

    function showGeneralError(text) {
        $generalError.innerText = text;
        $generalError.style.display = 'block';
    }

    function setLoading(loading) {
        let loadingEl = element.querySelector('.form__box') || element;
        if (loading) {
            loadingEl.classList.add('is-loading');
        } else {
            loadingEl.classList.remove('is-loading');
        }
    }

    function showThanks() {
        let thanks = element.querySelector('.form__success');
        if (!thanks) {
            return;
        }
        thanks.style.display = 'flex';
        setTimeout(function() {
            thanks.classList.add('form__success--visible');
        }, 1);
    }

    function clearFormErrors() {
        element.querySelectorAll('.has-error').forEach(el => el.classList.remove('has-error'));
        element.querySelectorAll('.form__error').forEach(el => el.style.display = 'none');
        $generalError.style.display = 'none';
    }

    return this;
}
